import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  ClearStoreOptions,
  CloseSidenav,
  OpenSidenav,
  PanelStatusChanged,
  ShowInactiveErrorsChanged,
  StoreCodeChanged,
  StoreNameChanged,
} from '../actions/search.actions';
import { StoreSearchState } from '../models/store.model';

const initialState: StoreSearchState = {
  sideNavOpened: false,
  panelExpanded: true,
  storeName: '',
  storeCode: '',
  showInactiveStores: false,
};

export const StoreManagementReducer = createReducer(
  initialState,
  on(OpenSidenav, (state) => ({
    ...state,
    sideNavOpened: true,
  })),
  on(CloseSidenav, (state) => ({
    ...state,
    sideNavOpened: false,
  })),
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(StoreNameChanged, (state, { storeName }) => ({
    ...state,
    storeName,
  })),
  on(StoreCodeChanged, (state, { storeCode }) => ({
    ...state,
    storeCode,
  })),
  on(ShowInactiveErrorsChanged, (state) => ({
    ...state,
    showInactiveStores: !state.showInactiveStores,
  })),
  on(ClearStoreOptions, (state) => ({
    ...state,
    storeName: '',
    storeCode: '',
    showInactiveStores: false,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    panelExpanded: true,
    tagType: '',
    tagCode: '',
    tagLabel: '',
    searchAvailable: false,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
